import { StatsigClient, StatsigUser } from '@statsig/js-client'
import { StatsigSessionReplayPlugin } from '@statsig/session-replay'
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics'
import packageJSON from '../../package.json'

const myStatsigClient = new StatsigClient(
  import.meta.env.VITE_STATSIG_CLIENT_KEY,
  {
    appVersion: packageJSON.version,
  },
  {
    plugins: [
      new StatsigSessionReplayPlugin({
      }),
      new StatsigAutoCapturePlugin(),
    ],
  },
)

export async function initStatsig() {
  await myStatsigClient.initializeAsync()
}

export async function identifyStatsigUser(user: StatsigUser) {
  await myStatsigClient.updateUserAsync(user)
}

export { myStatsigClient }
